import React from "react"
import { IProduto } from "app/types/produto/IProduto";

const estiloPesquisarCor = require("../pesquisa-cor.module.scss").default;

export type CorTintaSelecionadaProps = {
  codigoCorTinta: string
  descricaoCorTinta: string
  tintometricoSimplificado: boolean
}


export const CorTintaSelecionada = (props: CorTintaSelecionadaProps) => {
  return (
    <>
      <div className={estiloPesquisarCor.separador} />
      <div className={estiloPesquisarCor.dadosCorSelecionada}>
        <label>{props.tintometricoSimplificado ? "Código da Cor" : "Código da Cor do Fabricante"}</label>
        <div>{props.codigoCorTinta}</div>
        <label>{props.tintometricoSimplificado ? "Nome da Cor" : "Descrição da Cor"}</label>
        <div>{props.descricaoCorTinta}</div>
      </div>

    </>
  )
}